/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V3StackAdaptTacticDateRule {
    /**
    * Start date for the creative tactic in ISO format (YYYY-MM-DD)
    */
    'startDate'?: string;
    /**
    * Start hour for the creative tactic (0-23)
    */
    'startHour'?: number;
    /**
    * Start minute for the creative tactic (0-59)
    */
    'startMinute'?: number;
    /**
    * End date for the creative tactic in ISO format (YYYY-MM-DD)
    */
    'endDate'?: string;
    /**
    * End hour for the creative tactic (0-23)
    */
    'endHour'?: number;
    /**
    * End minute for the creative tactic (0-59)
    */
    'endMinute'?: number;
    /**
    * Time zone for the date rule
    */
    'timezone'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "string",
            "format": ""
        },
        {
            "name": "startHour",
            "baseName": "startHour",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "startMinute",
            "baseName": "startMinute",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "string",
            "format": ""
        },
        {
            "name": "endHour",
            "baseName": "endHour",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "endMinute",
            "baseName": "endMinute",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "timezone",
            "baseName": "timezone",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptTacticDateRule.attributeTypeMap;
    }

    public constructor() {
    }
}

